import { cn, NoddiIcon, type NoddiIconName } from 'noddi-ui-common';

interface Props {
  name: string;
  colorHex?: string | null;
  icon?: NoddiIconName | null;
  className?: string;
  selected?: boolean;
  size?: 'default' | 'sm';
}

export const NoddiTagBadge = ({ name, colorHex, icon, className, selected, size = 'default' }: Props) => {
  const color = !selected ? (colorHex ?? undefined) : undefined;
  const isSm = size === 'sm';

  return (
    <span
      className={cn(
        'inline-flex w-fit items-center border font-medium',
        !selected && 'text-foreground',
        isSm ? 'gap-0.5 rounded-full px-1 py-px text-[10px] leading-tight' : 'gap-1 rounded-full px-2 py-0.5 text-xs',
        // Selected tags inherit the card foreground without a wash that reduces its contrast.
        selected ? 'border-current/40' : !color && 'border-border bg-muted text-foreground',
        className
      )}
      style={
        color
          ? {
              borderColor: color,
              backgroundColor: `${color}1A`
            }
          : undefined
      }
    >
      {icon && <NoddiIcon name={icon} size='xSmall' />}
      {name}
    </span>
  );
};
